import React from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '~/tools/makeStyles';
import { CardContainer, TitleText, getAttributeBasedTitle } from './_shared';
import { DEFAULT_RESULTS_TRANSLATION } from '../../constants/results';

const useStyles = makeStyles((theme) => ({
  noTextContainer: {
    marginTop: theme.spacing(1),
  },
}));

export default function NoResultCard({
  isAttributeBased,
  questionAttributes,
  title,
  showLinkArea,
  attributes = [],
  translation = DEFAULT_RESULTS_TRANSLATION,
}) {
  const classes = useStyles();

  const attributesTitle = getAttributeBasedTitle(isAttributeBased, questionAttributes, attributes);

  const renderHeader = () => (
    <>
      <TitleText
        translation={translation}
        title={title}
        isAttributeBased={isAttributeBased}
        attributesTitle={attributesTitle}
        tabIndex={0}
      />
      <Typography className={classes.noTextContainer}>{translation.noEnoughData}</Typography>
    </>
  );

  return <CardContainer translation={translation} showLinkArea={showLinkArea} renderHeader={renderHeader} />;
}
